import { gql } from "@apollo/client";
import { OBJECT_FRAGMENT } from "@neoledger/graphql/fragments";

export const STREAM_THREAD = gql`
  ${OBJECT_FRAGMENT}
  subscription StreamThread(
    $threadIdentifier: String!
    $startDate: DateTime
    $endDate: DateTime
  ) {
    streamThread(threadIdentifier: $threadIdentifier) {
      messageIdentifier
      content {
        identifier
        createdAt
        order
        type
        status
        streamingAgentText
        toolName
        toolInput
        toolOutput
        toolError
        parentIdentifier
        executionMode
        iterationIndex
        pendingChange {
          identifier
          changeType
        }
        pendingSessionId
        context {
          identifier
          node {
            id
            ...Object
          }
        }
      }
      done
      stopped
      error
      message {
        id
        identifier
        createdAt
        content {
          id
          identifier
          createdAt
          text
          type
          status
          toolName
          toolInput
          toolOutput
          toolError
          executionMode
          iterationIndex
          parentIdentifier
          pendingChange {
            identifier
            changeType
          }
        }
        account {
          id
          identifier
        }
      }
    }
  }
`;

export const OBJECTS_CHANGED = gql`
  ${OBJECT_FRAGMENT}
  subscription ObjectsChanged(
    $entityIdentifier: ID!
    $startDate: DateTime
    $endDate: DateTime
  ) {
    objectsChanged(entityIdentifier: $entityIdentifier) {
      changes {
        action
        globalId
        typename
        node {
          id
          ...Object
        }
        related {
          action
          globalId
          typename
          node {
            id
            ...Object
          }
        }
      }
    }
  }
`;

export const Subscriptions = {
  STREAM_THREAD,
  OBJECTS_CHANGED,
} as const;
